import { render, staticRenderFns } from "./DetalhesHistorico.vue?vue&type=template&id=ebc1bc4a"
import script from "./DetalhesHistorico.vue?vue&type=script&lang=ts"
export * from "./DetalhesHistorico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports